/**
 * src/modules/bannerTextFade.js
 * * 功能：針對所有 .banner 區塊內的 .banner-header 執行 Mask 掃光浮現動畫
 * 觸發點：當 Banner 頂部到達視窗高度 40% 時
 */

export function initBannerTextFade() {
  // 1. 安全檢查：確認 GSAP 與 ScrollTrigger 是否存在
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP core or ScrollTrigger plugin is missing.');
    return;
  }

  // 註冊插件 (確保 ScrollTrigger 運作正常)
  gsap.registerPlugin(ScrollTrigger);

  // 2. 抓取所有帶有 .banner class 的元素
  // 使用 gsap.utils.toArray 可以確保跨瀏覽器的相容性，並轉為陣列
  const banners = gsap.utils.toArray('.banner');

  // 3. 遍歷每一個 Banner，個別建立動畫
  banners.forEach((banner) => {

    // 嘗試抓取該 Banner 內部的 Header
    // 這樣可以確保我們只動畫當前這個 Banner 的標題，而不會影響到別人的
    const header = banner.querySelector('.banner-header');
    const text = banner.querySelector('p');

    // 如果這個 Banner 裡面沒有 header，就跳過
    if (!header && !text) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: banner,
        start: "top 50%",
        toggleActions: "play none none reverse",
        // markers: true // 開發時開啟
      }
    });

    tl.fromTo(header, {
      "maskPosition": "100% 100%",
      "-webkit-mask-position": "100% 100%"
    },
      {
        "maskPosition": "0% 0%",
        "-webkit-mask-position": "0% 0%",
        duration: 3,
        ease: "power2.out"
      });

    if (text) {
      tl.fromTo(text,
        {
          "maskPosition": "100% 100%",
          "-webkit-mask-position": "100% 100%"
        },
        {
          "maskPosition": "0% 0%",
          "-webkit-mask-position": "0% 0%",
          duration: 3,
          ease: "power2.out"
        },
        // 關鍵在這裡！ Position Parameter
        // "<0.3" 代表：在「上一個動畫(Header) 開始」後的 0.3 秒執行
        "<0.5"
      );
    }
  });
}